export const PROGRAMATICAORGAO = 'PROGRAMATICAORGAO';
export const PROGRAMATICAORGAO_START = 'PROGRAMATICAORGAO_START';
export const PROGRAMATICAORGAO_SUCCESS = 'PROGRAMATICAORGAO_SUCCESS';
export const PROGRAMATICAORGAO_ERROR = 'PROGRAMATICAORGAO_ERROR';

export const PROGRAMATICAUNIDADE = 'PROGRAMATICAUNIDADE';
export const PROGRAMATICAUNIDADE_START = 'PROGRAMATICAUNIDADE_START';
export const PROGRAMATICAUNIDADE_SUCCESS = 'PROGRAMATICAUNIDADE_SUCCESS';
export const PROGRAMATICAUNIDADE_ERROR = 'PROGRAMATICAUNIDADE_ERROR';

export const PROGRAMATICAFUNCAO = 'PROGRAMATICAFUNCAO';
export const PROGRAMATICAFUNCAO_START = 'PROGRAMATICAFUNCAO_START';
export const PROGRAMATICAFUNCAO_SUCCESS = 'PROGRAMATICAFUNCAO_SUCCESS';
export const PROGRAMATICAFUNCAO_ERROR = 'PROGRAMATICAFUNCAO_ERROR';

export const PROGRAMATICASUBFUNCAO = 'PROGRAMATICASUBFUNCAO';
export const PROGRAMATICASUBFUNCAO_START = 'PROGRAMATICASUBFUNCAO_START';
export const PROGRAMATICASUBFUNCAO_SUCCESS = 'PROGRAMATICASUBFUNCAO_SUCCESS';
export const PROGRAMATICASUBFUNCAO_ERROR = 'PROGRAMATICASUBFUNCAO_ERROR';

export const PROGRAMATICAPROGRAMA = 'PROGRAMATICAPROGRAMA';
export const PROGRAMATICAPROGRAMA_START = 'PROGRAMATICAPROGRAMA_START';
export const PROGRAMATICAPROGRAMA_SUCCESS = 'PROGRAMATICAPROGRAMA_SUCCESS';
export const PROGRAMATICAPROGRAMA_ERROR = 'PROGRAMATICAPROGRAMA_ERROR';

export const PROGRAMATICAPROJETO = 'PROGRAMATICAPROJETO';
export const PROGRAMATICAPROJETO_START = 'PROGRAMATICAPROJETO_START';
export const PROGRAMATICAPROJETO_SUCCESS = 'PROGRAMATICAPROJETO_SUCCESS';
export const PROGRAMATICAPROJETO_ERROR = 'PROGRAMATICAPROJETO_ERROR';

export const PROGRAMATICACATEGORIAECONOMICA = 'PROGRAMATICACATEGORIAECONOMICA';
export const PROGRAMATICACATEGORIAECONOMICA_START =
  'PROGRAMATICACATEGORIAECONOMICA_START';
export const PROGRAMATICACATEGORIAECONOMICA_SUCCESS =
  'PPROGRAMATICACATEGORIAECONOMICA_SUCCESS';
export const PROGRAMATICACATEGORIAECONOMICA_ERROR =
  'PROGRAMATICACATEGORIAECONOMICA_ERROR';

export const PROGRAMATICAGRUPODESPESA = 'PROGRAMATICAGRUPODESPESA';
export const PROGRAMATICAGRUPODESPESA_START = 'PROGRAMATICAGRUPODESPESA_START';
export const PROGRAMATICAGRUPODESPESA_SUCCESS =
  'PROGRAMATICAGRUPODESPESA_SUCCESS';
export const PROGRAMATICAGRUPODESPESA_ERROR = 'PROGRAMATICAGRUPODESPESA_ERROR';

export const PROGRAMATICAELEMENTO = 'PROGRAMATICAELEMENTO';
export const PROGRAMATICAELEMENTO_START = 'PROGRAMATICAELEMENTO_START';
export const PROGRAMATICAELEMENTO_SUCCESS = 'PROGRAMATICAELEMENTO_SUCCESS';
export const PROGRAMATICAELEMENTO_ERROR = 'PROGRAMATICAELEMENTO_ERROR';

export const DESPESA = 'DESPESA';
export const DESPESA_START = 'DESPESA_START';
export const DESPESA_SUCCESS = 'DESPESA_SUCCESS';
export const DESPESA_ERROR = 'DESPESA_ERROR';

export const FONTE = 'FONTE';
export const FONTE_START = 'FONTE_START';
export const FONTE_SUCCESS = 'FONTE_SUCCESS';
export const FONTE_ERROR = 'FONTE_ERROR';
